<template>
  <b-card no-body>
    <b-card-header>
      <div class="d-flex align-items-center">
        <feather-icon size="24" class="mr-1" icon="VideoIcon" />
        <b-card-title class="ml-25">
          {{ $t("menu_name.conference") }}
        </b-card-title>
      </div>
    </b-card-header>

    <!-- timeline -->
    <b-card-body>
      <app-timeline>
        <app-timeline-item
          variant="info"
          v-for="(conference, index) in conferences"
          :key="index"
        >
          <div
            class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1"
          >
            <h6>
              {{ conference.hall }}
            </h6>
            <small class="timeline-item-time text-nowrap text-muted ml-1">{{
              conference.start
            }}</small>
          </div>
          <p>{{ conference.description }}</p>
        </app-timeline-item>
      </app-timeline>
      <!--/ timeline -->
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="info"
        href="conference"
      >
        {{ $t("dashboard.go_conference") }}
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BImg,
  BMedia,
  BMediaBody,
  BMediaAside,
  BAvatar,
  BAvatarGroup,
  VBTooltip,
  BButton,
} from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Ripple from "vue-ripple-directive";
import { getAllConferences } from "@api/conference";

export default {
  components: {
    BCard,
    BImg,
    BCardBody,
    BCardHeader,
    BCardTitle,
    AppTimeline,
    AppTimelineItem,
    BMedia,
    BAvatar,
    BMediaBody,
    BMediaAside,
    BAvatarGroup,
    BButton,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  methods: {
    getUser() {
      return this.$store.state.auth.user;
    },
    getNotification() {
      const $this = this;
      getAllConferences()
        .then((data) => {
          $this.conferences = data.map((item) => {
            return {
              id: item.id,
              hall: item.conference_hall.name,
              description: item.description,
              start: item.start,
            };
          });
          $this.conferences = $this.conferences.sort((a, b) =>
            a.start < b.start ? 1 : -1
          );
          $this.conferences = $this.conferences.slice(0, 5);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    let user = this.getUser();
    this.getNotification();
  },
  data() {
    return {
      conferences: [],
    };
  },
};
</script>
